module.exports = __webpack_public_path__ + "img/47.2a886b4f.png";